import { ReactNode } from 'react';
import { Button, Card } from '../components';
import { BlueLogoIcon } from '../iconography';

export interface LoginPageLayoutProps {
  isLoading: boolean;
  login: () => void;
  title: string;
  description: string;
  buttonLoadingText: string;
  buttonBaseText: string;
  backgroundImageSrc: string;
  infoMessage?: string;
  termsInfo?: ReactNode;
}

export const LoginPageLayout = ({
  isLoading,
  login,
  title,
  description,
  buttonLoadingText,
  buttonBaseText,
  backgroundImageSrc,
  infoMessage,
  termsInfo,
}: LoginPageLayoutProps) => (
  <div
    className="relative flex min-h-screen items-center justify-center bg-cover bg-center"
    style={{ backgroundImage: `url(${backgroundImageSrc})` }}
  >
    <Card className="animate-dissolve flex w-[90%] max-w-[450px] flex-col items-center justify-center gap-4 py-5">
      <div className="flex size-[200px] flex-col items-center justify-center rounded-full bg-[#01183F08]">
        <div className="flex size-[172px] items-center justify-center rounded-full bg-[#01183F0D]">
          <BlueLogoIcon />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-2 px-10">
        <h1 className="text-primary text-center">{title}</h1>
        <p className="text-muted-foreground">{description}</p>
      </div>
      <Button disabled={isLoading} onClick={login}>
        {isLoading ? buttonLoadingText : buttonBaseText}
      </Button>
      {isLoading && infoMessage && (
        <p className="text-muted-foreground text-center">{infoMessage}</p>
      )}
      {termsInfo && (
        <p className="text-muted-foreground text-center text-xs">{termsInfo}</p>
      )}
    </Card>
  </div>
);
